module.exports = __webpack_public_path__ + "img/finish.e831df2d.png";